import { readContract, } from "wagmi/actions";
import * as contracts from "@contracts";
import { wagmiConfig, } from "@config";
import { getConnectionInfo, } from "@helpers";
import { type TokenDefinition, type ChainId, } from "@bracket/addressbook";
import { cacheMap, cachedMap, cache_times, } from "./cache";
import moment from "moment";



export declare type GetRateProps = {
	token: TokenDefinition;
	attempt?: number;
	force?: boolean;
}


export const getRate = async ({
	token,
	attempt = 0,
	force = false,
}: GetRateProps): Promise<bigint> => {
	
	try {

		const now = moment().unix();
		const cachedRate = cachedRates.get(token.symbol);

		if(!force) {
			if(cachedRate) {
				const { value, since, } = cachedRate;
				if(now - since < cachedRateTTL) {
					return value;
				}
			}
		}

		const result = await readContract(wagmiConfig, contracts.IBracketOracle.getRate(token));
		if(typeof result === "bigint") {
			cachedRates.set(token.symbol, { since: now, value: result, });
			return result;
		}
		throw new Error("expected bigint not returned");
	}
	catch (err) {
		if(attempt < 3) {
			return await getRate({ token, attempt: attempt+1, });
		}
		throw new Error(`state::resolvers::getRate failed obtaining rate for token "${token.label}" on chain "1" after ${attempt} attempts:: ${err instanceof Error ? err?.message : "no error provided" }`);
	}

}


const cachedRateTTL = 3600; // 1 hour.
const cachedRates = new Map<string, { value: bigint, since: number}>();
